import { motion } from "framer-motion";
import { Mail, MapPin, Phone, Clock, Instagram } from "lucide-react";

const contact = [
  {
    icon: Phone,
    label: "Phone / WhatsApp",
    value: "+91 93912 00944",
    href: "https://wa.me/919391200944",
    testid: "contact-phone",
  },
  {
    icon: Mail,
    label: "Email",
    value: "ameerironandsteels@gmail.com",
    href: "mailto:ameerironandsteels@gmail.com",
    testid: "contact-email",
  },
  {
    icon: MapPin,
    label: "The Yard",
    value: "D.No. 3-82/7, Opp. S Convention, Mudidam, VT Agraharam, Vizianagaram, Malicherla, Andhra Pradesh - 535005",
    href: null,
    testid: "contact-address",
  },
  {
    icon: Clock,
    label: "Business Hours",
    value: "Mon – Sun, 8:00 AM – 7:30 PM",
    href: null,
    testid: "contact-hours",
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer-section">
      <div className="px-6 md:px-12 pt-24 md:pt-32 pb-12 border-t border-[#262626]" data-testid="address-heading">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl sm:text-6xl lg:text-8xl uppercase tracking-tight leading-none text-steel"
        >
          Address
        </motion.h2>
      </div>

      <div className="relative border-t border-[#262626]" data-testid="yard-map-section">
        <iframe
          title="Ameer Iron & Steels yard location"
          src="https://www.google.com/maps?q=Ameer%20Iron%20%26%20Steels%20Mudidam%20VT%20Agraharam%20Malicherla%20Vizianagaram%20535005&output=embed"
          className="w-full h-[380px] md:h-[440px] border-0 map-dark"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          data-testid="yard-map-iframe"
        />
        <div className="absolute bottom-6 left-6 md:left-12">
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Ameer%20Iron%20%26%20Steels%2C%20Mudidam%2C%20VT%20Agraharam%2C%20Malicherla%2C%20Vizianagaram%20535005"
            target="_blank"
            rel="noreferrer"
            className="bg-[#f5f5f5] text-[#050505] text-xs uppercase tracking-[0.2em] px-6 py-4 hover:bg-[#d4d4d4] transition-colors duration-300 inline-block"
            data-testid="get-directions-button"
          >
            Get Directions
          </a>
        </div>
      </div>

      <div id="contact" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#262626] border-b border-[#262626]">
        {contact.map((c, i) => {
          const Icon = c.icon;
          const inner = (
            <>
              <div className="flex items-center gap-3 mb-4 text-[#525252]">
                <Icon size={16} />
                <span className="text-xs uppercase tracking-[0.25em]">{c.label}</span>
              </div>
              <p className="text-sm md:text-base text-[#f5f5f5] break-words">{c.value}</p>
            </>
          );
          const cls =
            "bg-[#050505] p-8 md:p-10 hover:bg-[#121212] transition-colors duration-500 block";
          return (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
            >
              {c.href ? (
                <a href={c.href} className={cls} data-testid={c.testid} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
                  {inner}
                </a>
              ) : (
                <div className={cls} data-testid={c.testid}>{inner}</div>
              )}
            </motion.div>
          );
        })}
      </div>

      <div className="px-6 md:px-12 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <img src="/logo-monogram.png" alt="Ameer Iron & Steels" className="h-10 w-auto blend-screen" />
          <div>
            <p className="font-display text-sm uppercase tracking-[0.2em] text-steel-soft">Ameer Iron &amp; Steels</p>
            <p className="text-xs text-[#525252] mt-1">New iron, Iron Scrap, Plastic Scrap &amp; Vehicle Scrap - Bought &amp; Sold</p>
          </div>
        </div>
        <div className="flex items-center gap-6">
          <a
            href="https://www.instagram.com/ameerironsteels/"
            target="_blank"
            rel="noreferrer"
            aria-label="Ameer Iron & Steels on Instagram"
            className="text-[#737373] hover:text-[#f5f5f5] transition-colors duration-300"
            data-testid="instagram-link"
          >
            <Instagram size={22} />
          </a>
          <p className="text-xs text-[#3f3f3f] uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Ameer Iron &amp; Steels
          </p>
        </div>
      </div>
    </footer>
  );
}
